import React from 'react'

const Performance = ({
  size,
  style,
  primaryColor,
  secondaryColor,
  title = 'icon/performance',
  ...props
}) => (
  <svg height='75' width='121' viewBox='0 0 121 75' style={style} {...props}>
    <g fill='none' fillRule='evenodd'>
      <path
        d='M92.502 32.265l-7.225 1.276c-.527-2.999-1.575-5.822-3.05-8.374a26.166 26.166 0 0 0-5.734-6.82 25.613 25.613 0 0 0-7.716-4.466A25.424 25.424 0 0 0 60 12.333c-3.08 0-6.043.543-8.778 1.548a25.622 25.622 0 0 0-7.715 4.466 26.18 26.18 0 0 0-5.734 6.82 25.59 25.59 0 0 0-3.05 8.374l-7.225-1.276C30.212 16.77 43.735 5 60 5c16.265 0 29.788 11.77 32.502 27.265z'
        stroke={primaryColor}
        strokeWidth='2.25'
        strokeLinecap='round'
        strokeLinejoin='round' />
      <path
        d='M93 38c0 18.226-14.774 33-33 33S27 56.226 27 38 41.774 5 60 5s33 14.774 33 33zM59.633 38.367L71.367 25.9'
        stroke={primaryColor}
        strokeWidth='2.25'
        strokeLinecap='round'
        strokeLinejoin='round' />
      <path
        d='M65.867 38a5.867 5.867 0 1 1-11.734 0 5.867 5.867 0 0 1 11.734 0'
        fill={secondaryColor} />
    </g>
  </svg>
)

export default Performance
